import { Breadcrumbs, Link, Typography, Stack } from '@mui/material'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { findBreadcrumbs } from '@data/nav'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { useLang } from '@/i18n/useLang'
import { buildLangHref } from '@data/nav'
import { visuallyHidden } from '@mui/utils'

export default function NavBreadcrumbs() {
  const lang = useLang()
  const { pathname } = useLocation() 
  const items = findBreadcrumbs(pathname) || [] 
  const trail = [ 
    { 
      label: '홈', 
      href: '/', 
      icon: 
        <svg
          aria-label="홈"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ display: 'block' }}
        >
          <path
            d="M4 10.1277L12 4L20 10.1277V20H12H4V10.1277Z"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <rect
            x="8.75"
            y="13.25"
            width="6.5"
            height="6.5"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </svg>
      },
    ...items 
  ]

  return (
    <Breadcrumbs 
      aria-label="breadcrumb" 
      sx={{ height: '24px' }}
      separator={
        <ChevronRightIcon
          sx={{
            fontSize: '18px',
            width: '24px',
            mx: 0.5,
            color: 'grey.dark',
          }}
        />
      }
    >
      {trail.map((item, idx) =>
        idx < trail.length - 1 ? (
          <Link
            key={idx}
            component={RouterLink}
            to={buildLangHref(item.href, lang)}
            underline="hover"
            color="text.secondary"
            sx={{ typography: 'body2', display: 'flex', alignItems: 'center' }}
          >
            {item.icon ? (
              <Stack direction="row" alignItems="center">
                {item.icon}
                <span style={visuallyHidden}>{item.label}</span>
              </Stack>
            ) : (
              item.label
            )}
          </Link>
        ) : (
          <Typography
            key={idx}
            variant="body2"
            color="text.secondary"
            fontWeight={600}
            sx={{ display: 'flex', alignItems: 'center',  }}
          >
            {item.icon ? (
              <Stack direction="row" spacing={0.5} alignItems="center">
                {item.icon}
                <span>{item.label}</span>
              </Stack>
            ) : (
              item.label
            )}
          </Typography>
        )
      )}
    </Breadcrumbs>
  )
}
